/**
 * Phase 3b — Charles's story (shared between employee portal phase 1
 * Section D and the public `/employees` marketing page).
 *
 * Copy source: `/app/frontend/src/copy/narrative.js` → `CHARLES_STORY`.
 * Renders VERBATIM — every paragraph, unabridged. Editorial rules from
 * the brief §3.1 Section D:
 *   - Block-quote treatment, tinted `--paper-2` bg, generous padding.
 *   - Fraunces serif throughout.
 *   - Italic ONLY on the "Five employers. One policy. Same rate." beat.
 *   - Final takeaway couplet bold + coral accent, visually separated.
 *   - Footnote small, italic, muted.
 *
 * Accepts an optional `firstName` prop that renders a muted lead-in above
 * the story ("Alice, this is the kind of difference it makes.") — used in
 * the portal phase-1 context for personalization; omitted on `/employees`.
 */
import React from "react";

import { CHARLES_STORY } from "../../copy/narrative";
import "./CharlesStory.css";

export default function CharlesStory({ firstName = "", className = "" }) {
    return (
        <div
            className={`charles-story-wrap ${className}`}
            data-testid="charles-story"
        >
            {firstName && (
                <p className="charles-leadin" data-testid="charles-leadin">
                    {firstName}, this is the kind of difference it makes.
                </p>
            )}

            <blockquote className="charles-card">
                {CHARLES_STORY.segments.map((seg, i) => {
                    if (seg.type === "p") {
                        return (
                            <p key={i} className="charles-body">
                                {seg.text}
                            </p>
                        );
                    }
                    if (seg.type === "beat") {
                        return (
                            <p
                                key={i}
                                className="charles-beat"
                                data-testid="charles-beat"
                            >
                                <em>{seg.text}</em>
                            </p>
                        );
                    }
                    if (seg.type === "takeaway") {
                        return (
                            <div
                                key={i}
                                className="charles-takeaway"
                                data-testid="charles-takeaway"
                            >
                                {seg.leadin && (
                                    <p className="charles-body charles-takeaway-leadin">
                                        {seg.leadin}
                                    </p>
                                )}
                                <div
                                    className="charles-closing"
                                    data-testid="charles-closing"
                                >
                                    {seg.lines.map((ln, j) => (
                                        <p key={j} className="charles-closing-line">
                                            {ln}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        );
                    }
                    return null;
                })}
            </blockquote>
            <p className="charles-footnote mono" data-testid="charles-footnote">
                {CHARLES_STORY.footnote}
            </p>
        </div>
    );
}
